// This file is generated by the Webpack next-flight-loader.
import { registerClientReference } from "react-server-dom-webpack/server";
export default registerClientReference(
function() { throw new Error("Attempted to call the default export of \"/app/node_modules/@tremor/react/dist/components/icon-elements/Badge/Badge.js\" from the server, but it's on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
"/app/node_modules/@tremor/react/dist/components/icon-elements/Badge/Badge.js",
"default",
);
